/* PDP Tooltip */

function initTooltip() {
  const devlivery_label = document.querySelector('div.product__info-wrapper div.tpo_option-set-wrapper div.tpo_option-container[id*=dropdown] div.tpo_option-label-container');
  if(devlivery_label !== null){
    const tooltip = document.createElement('div');
    const tooltip_text = document.querySelector('.tooltip-text').innerHTML;
    tooltip.className = 'tooltip';
    tooltip.innerHTML = '<span class="info">info</span><div class="tooltip-content">'+tooltip_text+'</div>';
    devlivery_label.appendChild(tooltip);
  }
}

const observer = new MutationObserver(function(mutations_list) {
  mutations_list.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(added_node) {
      if(added_node.classList.contains("tpo_option-set-wrapper")) {
        initTooltip();
        observer.disconnect();
      }
    });
  });
});

observer.observe(document.querySelector(".product-form__buttons"), { subtree: false, childList: true });